import { convertQueryParamsToString } from "lib/util";
import BaseService from "./BaseService";
import AppConfiguration from "dataProvider/config";

export default class IotCameraService extends BaseService {
  constructor() {
    super(AppConfiguration.apiIotCamera, "");
  }

  /**
   * Lấy danh sách cấu hình cam cho băng tải
   * @param {*} params
   * @returns
   */
  postCameraPermissionByUserDetail(params) {
    const path = "/api/v1/camera-permissions/users/detail";
    return this.doPost(path, params);
  }

  getPositionDepartment(params) {
    const path = "/api/v1/positions/departments/list";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  postCameraPermissionByUserList(paramsPath, paramsBody) {
    const path =
      "/api/v1/camera-permissions/users/list" +
      convertQueryParamsToString(paramsPath);
    return this.doPost(path, paramsBody);
  }

  postCameraPermissionByUser(params) {
    const path = "/api/v1/camera-permissions/users";
    return this.doPost(path, params);
  }

  getCameraPermissionByPositionList(paramsPath, paramsBody) {
    const path =
      "/api/v1/camera-permissions/positions/list" +
      convertQueryParamsToString(paramsPath);
    return this.doPost(path, paramsBody);
  }

  getCameraPermissionByConfig(params) {
    const path = "/api/v1/camera-permissions/config";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  getCameraPermissionByPosition({ position_id }) {
    const path = `/api/v1/camera-permissions/positions/${position_id}`;
    return this.doGet(path);
  }

  postCameraPermissionByPosition(params) {
    const path = "/api/v1/camera-permissions/positions/create";
    return this.doPost(path, params);
  }

  getDvrByStation(params) {
    const path = "/api/v1/dvrs/get-by-station";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  getChannelByDvr(params) {
    const path = "/api/v1/channels/get-by-dvr";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  getProvinces() {
    const path = "/api/v1/addresses/provinces";
    return this.doGet(path);
  }

  getStationsPermissionFilter(params) {
    const path = "/api/v1/stations/permission-filter";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  deleteCameraPermissionByPosition(params) {
    const path = "/api/v1/camera-permissions/positions/delete";
    return this.doPost(path, params);
  }

  deleteCameraPermissionByUser(params) {
    const path = "/api/v1/camera-permissions/users/delete";
    return this.doPost(path, params);
  }

  updateCameraPermissionByUser(params) {
    const path = "/api/v1/camera-permissions/users/update";
    return this.doPost(path, params);
  }

  getCameraPermissionRequestsDetail(params) {
    const path = "/api/v1/camera-permissions/requests/detail";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  approveCameraPermissionRequest(params) {
    const path = "/api/v1/camera-permissions/requests/approve";
    return this.doPost(path, params);
  }

  rejectCameraPermissionRequest(params) {
    const path = "/api/v1/camera-permissions/requests/reject";
    return this.doPost(path, params);
  }

  createCameraPermissionRequest(params) {
    const path = "/api/v1/camera-permissions/requests/create";
    return this.doPost(path, params);
  }

  getRequestPermission(paramsPath, paramsBody) {
    const path =
      "/api/v1/camera-permissions/requests/list" +
      convertQueryParamsToString(paramsPath);
    return this.doPost(path, paramsBody);
  }

  deleteCameraPermissionRequest(params) {
    const path = "/api/v1/camera-permissions/requests/delete";
    return this.doPost(path, params);
  }

  getRequestDetail(params) {
    const path = "/api/v1/camera-permissions/requests/detail";
    return this.doPost(path, params);
  }

  createPermissionRequest(params) {
    const path = "/api/v1/camera-permissions/requests";
    return this.doPost(path, params);
  }

  getUserRolesList(paramsPath, paramsBody) {
    const path =
      "/api/v1/user-roles/list" + convertQueryParamsToString(paramsPath);
    return this.doPost(path, paramsBody);
  }

  getUserRoles() {
    return this.doGet("/api/v1/user-roles/get-roles");
  }

  searchUserByUsername(paramsPath, paramsBody) {
    const path =
      "/api/v1/users/search-by-username" +
      convertQueryParamsToString(paramsPath);
    return this.doPost(path, paramsBody);
  }

  addUserRole(params) {
    const path = "/api/v1/user-roles";
    return this.doPost(path, params);
  }

  permissionCameraUser(params) {
    const path = "/api/v1/users/cameras";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  addErrorAssign(params) {
    const path = "/api/v1/truck-camera-captures/5s-error-assign";
    return this.doPost(path, params);
  }

  /**
   * Get download logs for video downloads
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number (0-indexed)
   * @param {number} params.size - Page size
   * @param {string} [params.station_id] - Station/Warehouse ID
   * @param {string} [params.dvr_id] - DVR ID
   * @param {string} [params.channel_id] - Channel/Camera ID
   * @param {string} [params.time_start] - Start time filter
   * @param {string} [params.time_end] - End time filter
   * @returns {Promise}
   */
  getDownloadLogs(params) {
    const path = "/api/v1/download-logs";
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }

  /**
   * Get share URL for a download log
   * @param {string} id - Download log ID
   * @returns {Promise}
   */
  getDownloadLogShareUrl(id) {
    const path = `/api/v1/download-logs/${id}/share-url`;
    return this.doGet(path);
  }
}
